import { AdjacencyMatrixGraph, Edge } from "Math/Graph";
import * as React from "react";
import * as Sauce from "Sauce";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";
import { Position2 } from "Math/Geometry";
import * as _ from "lodash";
import * as Rx from "rxjs";
import * as Util from "Util";
import update = require('immutability-helper');
import { ValueProcessor } from "Sauce/Validation";
import { NumberInput, StringTextInput } from "Sauce/Form";
import { ParseResult } from "Sauce/Validation";
import { Real as RealNumber, Label } from "Sauce/Validation/Basic";
import { Latex } from "UI/Math/Latex";
import * as d3 from "d3";
import { Popover, PopoverTitle, PopoverContent, Button, Tooltip } from "reactstrap";
import { Vec2, AxisAlignedBox2 } from "Math/Algebra";
import { AnyRealExpression } from "Sauce/Validation/Basic";
import { DisplayNumberSpanWithPopover } from "UI/Math/DisplayNumber";
import { Matrix } from "Math/Matrix";
require("./Matrix.scss");
export interface Margin {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
}
export interface MatrixProps {
        matrix: Matrix<ParseResult<number>>; /* row major */
        outerWidth?: number;
        outerHeight?: number;
        columnLabels?: string[];
        leftRowLabels?: string[];
        rightRowLabels?: string[];
        margin?: Margin;
        flush?: (i: number, j: number, val: ParseResult<number>) => void;
}
export interface MatrixState {}

export class NumericMatrix extends Sauce.Component<MatrixProps, MatrixState> {
    constructor(props: MatrixProps) {
        super(props);
    }

    render() {
        const { leftRowLabels, rightRowLabels, columnLabels, flush, matrix } = this.props;
        let { outerWidth, outerHeight } = this.props;
        const margin = { ...{top: 0, left: 0, right: 0, bottom: 0}, ...this.props.margin}
        let rowLen = matrix.rows;
        let colLen = matrix.cols;
        
        if (!_.isFinite(outerWidth)) {
            outerWidth = colLen * 50 + margin.left + margin.right;
            if (leftRowLabels) outerWidth += 50;
            if (rightRowLabels) outerWidth += 50;
        }
        if (!_.isFinite(outerHeight)) {
            outerHeight = rowLen * 50 + margin.top + margin.bottom;
            if (columnLabels) outerHeight += 50;
        }
        
        let width = outerWidth - margin.left - margin.right;
        let height = outerHeight - margin.top - margin.bottom;

        let colLabelSize = columnLabels && columnLabels.length > 0 ? 1 : 0;
        let rowLabelSize = leftRowLabels && leftRowLabels.length > 0 ? 1 : 0;
        let rightRowLabelSize = rightRowLabels && rightRowLabels.length > 0 ? 1 : 0;
        let x = d3.scaleBand<number>()
            .rangeRound([0, width])
            .domain(d3.range(colLen + rowLabelSize + rightRowLabelSize));

       let y = d3.scaleBand<number>()
            .rangeRound([0, height])
            .domain(d3.range(rowLen + colLabelSize))
            .align(0);

        let entryEls:JSX.Element[] = [];
        for (let i = 0; i < rowLen; i++) {  
            for (let j = 0; j < colLen; j++) {
                let entry = matrix.getEntry(i, j);
                entryEls.push(<div 
                key={`${i}-${j}`}
                className="matrix-entry-container"
                style={{ 
                    top: y(i + colLabelSize), 
                    left: x(j + rowLabelSize),
                    backgroundColor: (i + j) % 2 ? "white" : "lightgrey",
                    width: x.bandwidth(),
                    height: y.bandwidth(),
                    border: entry && entry.valid ? "1px solid black" : "1px solid red",
                    borderBottom: i === rowLen - 1 ? "1px solid black" : "none",
                    borderRight: j === colLen - 1 ? "1px solid black" : "none",
                }}>
                {
                flush ?
                <NumberInput
                    value={entry}
                    className="matrix-entry-input"
                    flush={val => flush(i, j, val)}
                    processor={AnyRealExpression}/>
                :
                <DisplayNumberSpanWithPopover 
                    num={entry} 
                    className="matrix-entry-number"
                    displayRaw={true}
                    maxPrecision={7}
                    minPrecision={3}
                    maxWidth={x.bandwidth()}></DisplayNumberSpanWithPopover>
                }
                </div>)
            }
        }
        let colLabelEls : JSX.Element[] = [];
        if (columnLabels) {
            for (let j = 0; j < columnLabels.length; j++) {
                let i = 0;
                colLabelEls.push(<div
                    className="matrix-entry-container"
                    key={`${i}-${j}`}
                    style={{ 
                    top: y(0), 
                    left: x(j + rowLabelSize),
                    backgroundColor: (j) % 2 ? "white" : "lightgrey",
                    width: x.bandwidth(),
                    height: y.bandwidth() }}>{columnLabels[j]}</div>)
            }
        }
        let rowLabelEls : JSX.Element[] = [];
        if (leftRowLabels) {
            for (let i = 0; i < leftRowLabels.length; i++) {
                let j = 0;
                rowLabelEls.push(<div
                    className="matrix-entry-container"
                    key={`${i}-${j}`}
                    style={{ 
                    top: y(i + colLabelSize), 
                    left: x(0),
                    backgroundColor: (i) % 2 ? "white" : "lightgrey",
                    width: x.bandwidth(),
                    height: y.bandwidth() }}>{leftRowLabels[i]}</div>)
            }
        }
        if (rightRowLabels) {
            for (let i = 0; i < rightRowLabels.length; i++) {
                let j = colLen + rowLabelSize;
                rowLabelEls.push(<div
                    className="matrix-entry-container"
                    key={`${i}-${j}`}
                    style={{ 
                    top: y(i + colLabelSize), 
                    left: x(j),
                    backgroundColor: (i) % 2 ? "white" : "lightgrey",
                    width: x.bandwidth(),
                    height: y.bandwidth() }}><span className='right-row-label'>{rightRowLabels[i]}</span></div>)
            }
        }
        return <div className="matrix-container" style={{ width: outerWidth, height: outerHeight}}>{rowLabelEls}{colLabelEls}{entryEls}</div>;
    }
}


// WEBPACK FOOTER //
// ./src/code/UI/Math/Matrix.tsx